export default __webpack_public_path__ + "static/img_growing_together_3@2x-6856286411ca37eee03d59623cf10f62.png";